import { render, staticRenderFns } from "./three_info.vue?vue&type=template&id=03c24ab0&scoped=true&"
import script from "./three_info.vue?vue&type=script&lang=js&"
export * from "./three_info.vue?vue&type=script&lang=js&"
import style0 from "./three_info.vue?vue&type=style&index=0&id=03c24ab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c24ab0",
  null
  
)

export default component.exports